"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    popoverSurfaceClassNames: function() {
        return popoverSurfaceClassNames;
    },
    arrowHeights: function() {
        return arrowHeights;
    },
    usePopoverSurfaceStyles_unstable: function() {
        return usePopoverSurfaceStyles_unstable;
    }
});
const _react = require("@griffel/react");
const popoverSurfaceClassNames = {
    root: 'fui-PopoverSurface'
};
const arrowHeights = {
    small: 6,
    medium: 8,
    large: 8
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        sj55zd: "f19n0e5",
        De3pzq: "fxugw4r",
        E5pizo: "f1hg901r",
        Bbmb7ep: [
            "f1aa9q02",
            "f16jpd5f"
        ],
        Beyfa6y: [
            "f16jpd5f",
            "f1aa9q02"
        ],
        B7oj6ja: [
            "f1jar5jt",
            "fyu767a"
        ],
        Btl43ni: [
            "fyu767a",
            "f1jar5jt"
        ],
        B4j52fo: "f5ogflp",
        Bekrc4i: [
            "f1hqa2wf",
            "finvdd3"
        ],
        Bn0qgzm: "f1f09k3d",
        ibv6hh: [
            "finvdd3",
            "f1hqa2wf"
        ],
        icvyot: "fzkkow9",
        vrafjx: [
            "fcdblym",
            "fjik90z"
        ],
        oivjwe: "fg706s2",
        wvpqe5: [
            "fjik90z",
            "fcdblym"
        ],
        g2u3we: "fghlq4f",
        h3c5rm: [
            "f1gn591s",
            "fjscplz"
        ],
        B9xav0g: "fb073pr",
        zhjwy3: [
            "fjscplz",
            "f1gn591s"
        ],
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi",
        B93otf3: "f18k4bn6",
        vin17d: "fo1kyvf",
        Ezkn3b: "fetxo7e",
        nyiy2g: "f8x1vz1",
        swvrvq: "f8g0anz",
        Bkovbt3: "fezwn9i",
        hgjdhn: "fz5efge",
        fsy9dk: "f1ydixl4",
        B3ogreh: "f8dgqj5",
        jv49x5: "fnyfnr8",
        Bk7o48c: "fgw77r4",
        Bv12yb3: "ftje0s4",
        z0t1cu: "fi19xcv",
        Bks05zx: "f1mzajhk",
        Bvtglag: "fjp4h9y"
    },
    inline: {
        Bj3rh1h: "f19g0ac"
    },
    inverted: {
        De3pzq: "fg3r6xk",
        sj55zd: "fonrgv7"
    },
    brand: {
        De3pzq: "ffp7eso",
        sj55zd: "f1phragk"
    },
    smallPadding: {
        z8tnut: "f1kcqot9",
        z189sj: [
            "f11qrl6u",
            "fjlbh76"
        ],
        Byoj8tv: "fpe6lb7",
        uwmqm3: [
            "fjlbh76",
            "f11qrl6u"
        ]
    },
    mediumPadding: {
        z8tnut: "fqag9an",
        z189sj: [
            "f1gbmcue",
            "f1rh9g5y"
        ],
        Byoj8tv: "fp67ikv",
        uwmqm3: [
            "f1rh9g5y",
            "f1gbmcue"
        ]
    },
    largePadding: {
        z8tnut: "fc7z3ec",
        z189sj: [
            "fat0sn4",
            "fekwl8i"
        ],
        Byoj8tv: "fe2my4m",
        uwmqm3: [
            "fekwl8i",
            "fat0sn4"
        ]
    },
    smallArrow: {
        a9b677: "f1ekdpwm",
        Bqenvij: "f83vc9z"
    },
    mediumLargeArrow: {
        a9b677: "f1kmc0fn",
        Bqenvij: "fb6lvc5"
    },
    arrow: {
        qhf8xq: "f1euv43f",
        De3pzq: "f1u2r49w",
        Bcdw1i0: "fd7fpy0",
        Bj3rh1h: "f1bsuimh",
        Ftih45: "f1wl9k8s",
        B1puzpu: "f1wkw4r9",
        Brfgrao: "f1j7ml58",
        Bcvre1j: "fyl8oag",
        Ccq8qp: "frdoeuz",
        Baz25je: "fb81m9q",
        cmx5o7: "f1ljr5q2",
        B4f6apu: "fyfemzf",
        m598lv: "focyt6c",
        Bk5zm6e: "fnhxbxj",
        y0oebl: "fdw6hkg",
        qa3bma: "f11yjt3y",
        Bqjgrrk: "f1172wan",
        Budzafs: [
            "f9e5op9",
            "f112wvtl"
        ],
        Hv9wc6: "f16cagkn",
        hl6cv3: "f1773hnp",
        c8svkw: "fw7o64x",
        yayu3t: "f1v7783n",
        nr3p0k: "f1f0d6v",
        rhl9o9: "fh2hsk5",
        wiz9v7: "f1gj3y7g",
        B6q6orb: "f11yvu4",
        ndpsmx: "f17lejdj"
    }
}, {
    d: [
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f1hg901r{box-shadow:var(--shadow16);}",
        ".f1aa9q02{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f16jpd5f{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f1jar5jt{border-top-right-radius:var(--borderRadiusMedium);}",
        ".fyu767a{border-top-left-radius:var(--borderRadiusMedium);}",
        ".f5ogflp{border-top-width:1px;}",
        ".f1hqa2wf{border-right-width:1px;}",
        ".finvdd3{border-left-width:1px;}",
        ".f1f09k3d{border-bottom-width:1px;}",
        ".fzkkow9{border-top-style:solid;}",
        ".fcdblym{border-right-style:solid;}",
        ".fjik90z{border-left-style:solid;}",
        ".fg706s2{border-bottom-style:solid;}",
        ".fghlq4f{border-top-color:var(--colorTransparentStroke);}",
        ".f1gn591s{border-right-color:var(--colorTransparentStroke);}",
        ".fjscplz{border-left-color:var(--colorTransparentStroke);}",
        ".fb073pr{border-bottom-color:var(--colorTransparentStroke);}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".f18k4bn6{animation-composition:accumulate;}",
        ".fo1kyvf{animation-duration:var(--durationSlower);}",
        ".fetxo7e{animation-timing-function:var(--curveDecelerateMid);}",
        ".f8x1vz1{--fui-positioning-slide-distance-x:0px;}",
        ".f8g0anz{--fui-positioning-slide-distance-y:10px;}",
        ".fezwn9i[data-popper-placement^=right]{--fui-positioning-slide-distance-x:-10px;}",
        ".fz5efge[data-popper-placement^=right]{--fui-positioning-slide-distance-y:0px;}",
        ".f1ydixl4[data-popper-placement^=bottom]{--fui-positioning-slide-distance-x:0px;}",
        ".f8dgqj5[data-popper-placement^=bottom]{--fui-positioning-slide-distance-y:-10px;}",
        ".fnyfnr8[data-popper-placement^=left]{--fui-positioning-slide-distance-x:10px;}",
        ".fgw77r4[data-popper-placement^=left]{--fui-positioning-slide-distance-y:0px;}",
        ".ftje0s4{animation-name:f5j8bii,f79suad;}",
        ".f19g0ac{z-index:1;}",
        ".fg3r6xk{background-color:var(--colorNeutralBackgroundStatic);}",
        ".fonrgv7{color:var(--colorNeutralForegroundStaticInverted);}",
        ".ffp7eso{background-color:var(--colorBrandBackground);}",
        ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}",
        ".f1kcqot9{padding-top:12px;}",
        ".f11qrl6u{padding-right:12px;}",
        ".fjlbh76{padding-left:12px;}",
        ".fpe6lb7{padding-bottom:12px;}",
        ".fqag9an{padding-top:16px;}",
        ".f1gbmcue{padding-right:16px;}",
        ".f1rh9g5y{padding-left:16px;}",
        ".fp67ikv{padding-bottom:16px;}",
        ".fc7z3ec{padding-top:20px;}",
        ".fat0sn4{padding-right:20px;}",
        ".fekwl8i{padding-left:20px;}",
        ".fe2my4m{padding-bottom:20px;}",
        ".f1ekdpwm{width:8.484px;}",
        ".f83vc9z{height:8.484px;}",
        ".f1kmc0fn{width:11.312px;}",
        ".fb6lvc5{height:11.312px;}",
        ".f1euv43f{position:absolute;}",
        ".f1u2r49w{background-color:inherit;}",
        ".fd7fpy0{visibility:hidden;}",
        ".f1bsuimh{z-index:-1;}",
        ".f1wl9k8s::before{content:\"\";}",
        ".f1wkw4r9::before{visibility:visible;}",
        ".f1j7ml58::before{position:absolute;}",
        ".fyl8oag::before{box-sizing:border-box;}",
        ".frdoeuz::before{width:inherit;}",
        ".fb81m9q::before{height:inherit;}",
        ".f1ljr5q2::before{background-color:inherit;}",
        ".fyfemzf::before{border-right-width:1px;}",
        ".focyt6c::before{border-right-style:solid;}",
        ".fnhxbxj::before{border-right-color:var(--colorTransparentStroke);}",
        ".fdw6hkg::before{border-bottom-width:1px;}",
        ".f11yjt3y::before{border-bottom-style:solid;}",
        ".f1172wan::before{border-bottom-color:var(--colorTransparentStroke);}",
        ".f9e5op9::before{border-bottom-right-radius:var(--borderRadiusSmall);}",
        ".f112wvtl::before{border-bottom-left-radius:var(--borderRadiusSmall);}",
        ".f16cagkn::before{transform:rotate(var(--fui-positioning-angle)) translate(0, 50%) rotate(45deg);}",
        "[data-popper-placement^=\"top\"] .f1773hnp{bottom:-1px;}",
        "[data-popper-placement^=\"top\"] .fw7o64x{--fui-positioning-angle:0;}",
        "[data-popper-placement^=\"right\"] .f1v7783n{left:-1px;}",
        "[data-popper-placement^=\"right\"] .f1f0d6v{--fui-positioning-angle:90deg;}",
        "[data-popper-placement^=\"bottom\"] .fh2hsk5{top:-1px;}",
        "[data-popper-placement^=\"bottom\"] .f1gj3y7g{--fui-positioning-angle:180deg;}",
        "[data-popper-placement^=\"left\"] .f11yvu4{right:-1px;}",
        "[data-popper-placement^=\"left\"] .f17lejdj{--fui-positioning-angle:270deg;}"
    ],
    k: [
        "@keyframes f5j8bii{from{opacity:0;}to{opacity:1;}}",
        "@keyframes f79suad{from{transform:translate(var(--fui-positioning-slide-distance-x), var(--fui-positioning-slide-distance-y));}}"
    ],
    m: [
        [
            "@media (prefers-reduced-motion){.fi19xcv[data-popper-placement]{animation-duration:1ms;}}",
            {
                m: "(prefers-reduced-motion)"
            }
        ],
        [
            "@media (prefers-reduced-motion){.f1mzajhk[data-popper-placement]{animation-name:f5j8bii;}}",
            {
                m: "(prefers-reduced-motion)"
            }
        ]
    ],
    t: [
        "@supports not (animation-composition: accumulate){.fjp4h9y[data-popper-placement]{animation-name:f5j8bii;}}"
    ]
});
const usePopoverSurfaceStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(popoverSurfaceClassNames.root, styles.root, state.inline && styles.inline, state.size === 'small' && styles.smallPadding, state.size === 'medium' && styles.mediumPadding, state.size === 'large' && styles.largePadding, state.appearance === 'inverted' && styles.inverted, state.appearance === 'brand' && styles.brand, state.root.className);
    state.arrowClassName = (0, _react.mergeClasses)(styles.arrow, state.size === 'small' ? styles.smallArrow : styles.mediumLargeArrow);
    return state;
}; //# sourceMappingURL=usePopoverSurfaceStyles.styles.js.map
